import { z } from "zod";
import { addDays, addMonths, addYears } from "@pack-it-up/shared";
export const TimeUnitSchema = z.enum(["day", "week", "month", "year"]);
export const RelativeOffsetSchema = z.object({
    value: z.number().int(),
    unit: TimeUnitSchema,
});
// Pure calendar math — no timezone exists in this signature (Doc 07 §4).
// day/week are exact; month/year are calendar-aware with end-of-month clamping.
export const resolve = (start, offset) => {
    switch (offset.unit) {
        case "day":
            return addDays(start, offset.value);
        case "week":
            return addDays(start, offset.value * 7);
        case "month":
            return addMonths(start, offset.value);
        case "year":
            return addYears(start, offset.value);
    }
};
// Human-readable copy for UI controls and email bodies, e.g. "2 weeks before start".
export const formatOffset = (offset) => {
    if (offset.value === 0)
        return "on start";
    const n = Math.abs(offset.value);
    const unit = n === 1 ? offset.unit : `${offset.unit}s`;
    const direction = offset.value < 0 ? "before" : "after";
    return `${n} ${unit} ${direction} start`;
};
//# sourceMappingURL=relativeOffset.js.map